import React from 'react'
import { Card, Button } from 'react-angle-dashboard-components'
import { treatments } from './data'
import { StyledCard, CardFirstHalf, CardSecondHalf } from './style'

// const doctorOnDemandUrls = {
//   test: 'https://patient-demo.doctorondemand.com/sso/oidc/web/start/?idp_connection_id=angle-health-test&app_type=3',
//   prod: 'https://patient.doctorondemand.com/sso/oidc/web/start/?idp_connection_id=angle-health&app_type=3&status_response_url=https://doctorondemand.onelink.me/doctorondemand/f4854b1e'
// }

// const doctorOnDemandUrl = window.location.origin.includes('test')
//   ? doctorOnDemandUrls.test
//   : doctorOnDemandUrls.prod

export const VirtualCareCard: React.FC = () => {
  return (
    <StyledCard>
      <Card.Body className="d-flex flex-column flex-md-row">
        <CardFirstHalf>
          <h3 className="mb-3">Get virtual access to care anytime</h3>
          <div className="d-flex justify-content-start align-items-center">
            <img
              src="/dr-plus.png"
              alt="doctor on demand"
              width={100}
              style={{ marginLeft: -15 }}
            />
            <div
              className="ml-2 h-100 d-flex flex-column justify-content-center"
              style={{ marginTop: -10 }}
            >
              <h4 className="mb-0">Angle Telehealth</h4>
              <p className="mb-0">
                brought to you by <b>Doctor on Demand</b>
              </p>
            </div>
          </div>
          <p className="mb-0">
            We partner with Doctor on Demand to bring you access to telehealth{' '}
            <b>24/7</b>. You can use your Angle credentials to log in and get
            started.
          </p>
          <Button
            size="md"
            className="my-5"
            onClick={() =>
              window.open(
                'https://member.anglehealth.com/virtual-care',
                '_blank  noreferrer'
              )
            }
          >
            Member Portal Login
          </Button>
        </CardFirstHalf>
        <CardSecondHalf>
          <p className="font-weight-bold">Virtual Care can help you treat:</p>
          <ul className="m-0 pl-4">
            {treatments.map((x, i) => (
              <li key={i}>{x}</li>
            ))}
          </ul>
          <div style={{ marginTop: 20 }}>
            <small>Questions about Angle Telehealth?</small>
            <small className="d-block">
              Chat with your care team directly from your mobile app.
            </small>
          </div>
        </CardSecondHalf>
      </Card.Body>
    </StyledCard>
  )
}
